import React, {Fragment} from 'react';

import './image-sequence.css';


export default ({n, mobileN, imageGetter}) => {
    const indices = [...Array(n).keys()];
    const images = indices.map(i => {
        const arrowDisplay = {display: (i === 0) ? 'none' : 'inline-block'};
        const [src, size, altText] = imageGetter(i);
        return <Fragment key={i}>
            <span
                className='arrow desktop'
                style={arrowDisplay}
            >→</span>
            {i < mobileN ? 
                <span
                    className='arrow mobile'
                    style={arrowDisplay}
                >↓</span> : null}
            <img
                key={i}
                alt={altText}
                src={src}
                width={Math.round(size)} height={Math.round(size)}
                className={i < mobileN ? null : 'desktop'}
            />
        </Fragment>;
    });
    return <div className='image-sequence-container'>
        {images}
    </div>;
}
